import { getDataIdsFromContract } from '../../../../../shared/utils/dataId';

export const FLAT_FILE_OBJECT_CONFIG_FORM_DATA_IDS = getDataIdsFromContract({
  base: 'flat-file-object-config',
  form: 'form',
  submitCTA: 'submit',
  errorBanner: 'error',
  template: 'template'
});
